import { useSelectWarehouse } from '../../features/adminInventory/useSelectWarehouse';
import useAdminInventoryStore from '../../store/useAdminInventoryStore';

const WarehouseSelector = () => {
  const supplier = useAdminInventoryStore((state) => state.filters.supplier);
  const warehouse = useAdminInventoryStore((state) => state.filters.warehouse);
  const setWarehouse = useAdminInventoryStore((state) => state.setWarehouse);

  const { data = [], isLoading } = useSelectWarehouse(supplier?.id);

  const handleChange = (e) => {
    const value = e.target.value;

    if (!value) {
      setWarehouse(null);
      return;
    }

    const selectedWarehouse = data.find((item) => String(item.id) === value);
    setWarehouse(selectedWarehouse || null);
  };

  return (
    <div className="w-full">
      <label className="mb-1 block text-sm font-medium text-gray-700">
        انبار
      </label>

      <select
        value={warehouse?.id || ''}
        onChange={handleChange}
        disabled={!supplier || isLoading}
        className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-blue-500 disabled:bg-gray-100"
      >
        <option value="">
          {!supplier
            ? 'ابتدا تأمین کننده را انتخاب کنید'
            : isLoading
            ? 'در حال دریافت انبارها...'
            : 'انتخاب انبار'}
        </option>

        {data.map((item) => (
          <option key={item.id} value={item.id}>
            {item.title} - {item.city_name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default WarehouseSelector;
